<template>
    <div :class="['flex', 'flex-col', 'mt-4', detail ? 'w-48 items-start' : 'w-32 items-center']">
        <div class="mt-1 cursor-pointer flex items-center justify-center mb-4 mx-auto">
            <div :class="['badge', 'badge-primary', 'badge-lg', detail ? 'w-16' : 'w-8']" @click="handleSetDetail"></div>
        </div>
        <div class="mt-2">
            <div class="drawer">
                <input id="batch-settings" type="checkbox" class="drawer-toggle" v-model="settingCheckBox" />
                <div class="drawer-content">
                    <!-- Page content here -->
                    <label for="batch-settings"
                        :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content drawer-button', !detail ? 'tooltip tooltip-top' : '']"
                        data-tip="配置">
                        <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                        <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                            <svg t="1704707420078" class="icon fill-current w-16 h-6" viewBox="0 0 1024 1024"
                                version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2430" width="200" height="200">
                                <path
                                    d="M511.099222 365.825763c-80.7786 0-146.26579 65.482515-146.26579 146.259556 0 80.7786 65.48719 146.259556 146.26579 146.259556 80.777041 0 146.259556-65.480957 146.259556-146.259556C657.358779 431.308278 591.876263 365.825763 511.099222 365.825763L511.099222 365.825763zM511.099222 585.215097c-40.391637 0-73.136012-32.742816-73.136012-73.129778 0-40.391637 32.742816-73.129778 73.136012-73.129778 40.386962 0 73.129778 32.738141 73.129778 73.129778C584.229 552.472281 551.486184 585.215097 511.099222 585.215097L511.099222 585.215097zM511.099222 585.215097M900.893017 568.24369l-26.451395-15.268032c3.065451-27.021784 3.138697-54.472139 0.077922-81.822754l26.373473-15.225955c69.953678-40.391637 93.920921-129.844512 53.533959-199.799749-40.390079-69.95212-129.839837-93.925596-199.799749-53.533959l-26.373473 15.225955c-22.153219-16.330888-45.963059-29.99217-70.896534-40.843585l0-30.545416c0-80.777041-65.48719-146.259556-146.26579-146.259556-80.7786 0-146.259556 65.482515-146.259556 146.259556l0 30.515806c-12.377127 5.421811-24.587501 11.55583-36.562551 18.473743-11.97505 6.917913-23.396854 14.420242-34.277879 22.432179l-26.431136-15.258682c-69.958353-40.391637-159.406553-16.424395-199.79819 53.533959C27.378272 326.082437 51.343956 415.535311 121.299193 455.922273l26.449837 15.275825c-3.063892 27.020226-3.137139 54.465905-0.077922 81.822754l-26.373473 15.224397c-69.953678 40.391637-93.920921 129.841395-53.533959 199.799749 40.391637 69.95212 129.839837 93.920921 199.79819 53.533959l26.375032-15.224397c22.153219 16.32933 45.963059 29.984378 70.896534 40.843585l0 30.537624c0 80.7786 65.48719 146.26579 146.26579 146.26579 80.777041 0 146.259556-65.48719 146.259556-146.26579l0-30.515806c12.377127-5.415577 24.587501-11.55583 36.567226-18.467509 11.97505-6.917913 23.398412-14.420242 34.277879-22.432179l26.423343 15.258682c69.959912 40.391637 159.408111 16.418162 199.799749-53.533959C994.813938 698.085085 970.848254 608.635327 900.893017 568.24369L900.893017 568.24369zM891.096666 731.474653c-20.198936 34.982294-64.923035 46.962019-99.900654 26.770875l-63.331869-36.567226 0 0 0 0-7.988562-4.611422c-18.134004 18.450366-39.024886 34.787489-62.516805 48.353705-23.49971 13.559983-48.091888 23.482568-73.129778 29.964118l0 9.222846 0 0 0 65.828489 0 7.301289c0 40.391637-32.742816 73.136012-73.136012 73.136012-40.386962 0-73.129778-32.742816-73.129778-73.136012l0-7.402588 0-65.72719 0 0 0-9.300768c-50.682014-13.090892-97.855981-39.682547-135.652816-78.232109l-7.983886 4.606747 0 0-63.331869 36.567226c-34.977618 20.191144-79.706394 8.206743-99.900654-26.770875-20.192702-34.977618-8.206743-79.701718 26.770875-99.899095l6.341291-3.657657 0 0 64.972905-37.516316c-14.487254-52.005129-13.929333-106.151555 0.073247-156.593569l-8.057133-4.650384 0 0-63.331869-36.567226c-34.982294-20.192702-46.963578-64.923035-26.770875-99.900654 20.192702-34.97606 64.923035-46.962019 99.900654-26.763083l6.324148 3.649866 0 0 64.996282 37.528784c18.132445-18.450366 39.024886-34.790606 62.516805-48.353705 23.493477-13.559983 48.085654-23.485685 73.129778-29.964118l0-9.229079L437.960093 153.739276l0-7.309082c0-40.385404 32.742816-73.129778 73.129778-73.129778 40.391637 0 73.129778 32.744375 73.129778 73.129778l0 7.404147 0 65.72719 0 9.307001c50.686689 13.086217 97.862215 39.684106 135.657491 78.232109l48.487732-27.997368 22.828023-13.176607c34.977618-20.192702 79.701718-8.212977 99.89442 26.763083 20.198936 34.982294 8.212977 79.706394-26.764641 99.900654l-30.822819 17.79738-32.50905 18.769847 0 0 0 0-7.983886 4.605189c14.488813 52.009805 13.929333 106.159347-0.077922 156.599803l64.979139 37.511641 0 0 6.414537 3.701294C899.303409 651.772936 911.289368 696.498594 891.096666 731.474653L891.096666 731.474653zM891.096666 731.474653M197.330785 324.240361c-1.932465 3.232203-3.824411 6.497135-5.649343 9.785442L197.330785 324.240361 197.330785 324.240361zM197.330785 324.240361M830.515443 690.133926l-5.655577 9.804144C826.793889 696.699632 828.685835 693.433143 830.515443 690.133926L830.515443 690.133926zM830.515443 690.133926M505.297151 146.430195l11.304921 0C512.835324 146.369416 509.067017 146.374091 505.297151 146.430195L505.297151 146.430195zM505.297151 146.430195M516.898176 877.740444l-11.31583 0C509.350653 877.796547 513.125193 877.796547 516.898176 877.740444L516.898176 877.740444zM516.898176 877.740444">
                                </path>
                            </svg>
                            <div v-if="detail" class="mr-auto">配置</div>
                        </span>
                    </label>
                </div>
                <div class="drawer-side">
                    <label for="batch-settings" aria-label="close sidebar" class="drawer-overlay"></label>
                    <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-96">
                        <div class="flex justify-between items-center mb-4">
                            <div class="text-xl font-medium">详情显示设置</div>
                            <button class="btn btn-sm btn-primary" @click="handleBatchSettings">保存</button>
                        </div>
                        <div>
                            <div class="form-control">
                                <label class="label cursor-pointer">
                                    <span class="label-text">开启详情页</span>
                                    <input type="checkbox" class="toggle toggle-primary"
                                        v-model="batchSettingFormData.isOpenDetail" />
                                </label>
                            </div>
                            <div class="form-control">
                                <label class="label cursor-pointer">
                                    <span class="label-text">开启深度遍历</span>
                                    <input type="checkbox" class="toggle toggle-primary"
                                        v-model="batchSettingFormData.isDepth" />
                                </label>
                                <div class="text-gray-400 text-sm">会显示子文件夹下的文件信息</div>
                            </div>
                            <div class="form-control">
                                <label class="label cursor-pointer">
                                    <span class="label-text">限制条数</span>
                                    <input type="number" placeholder="请输入"
                                        class="input input-bordered input-sm max-w-xs"
                                        v-model="batchSettingFormData.limit" />
                                </label>
                                <div class="text-gray-400 text-sm">显示详情列表的条数,避免卡住页面</div>
                            </div>
                            <div class="form-control">
                                <label class="label cursor-pointer">
                                    <span class="label-text">显示字段</span>
                                </label>
                                <multi-select :options="fieldListID3" v-model="showFieldsID3"></multi-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--手动刮削-->
        <div class="mt-2">
            <label for="hand-edit"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content drawer-button', !detail ? 'tooltip tooltip-top' : '']"
                data-tip="手动刮削">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else :class="['flex mt-1', 'items-center', detail ? 'w-40' : '']">
                    <svg viewBox="0 0 15 15" class="icon fill-current w-16 h-5" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.9697 0.969727L4.96973 8.96973L6.03039 10.0304L14.0304 2.03039L12.9697 0.969727Z" />
                        <path
                            d="M2.5 1.25006C1.25736 1.25006 0.25 2.25742 0.25 3.50006V12.5001C0.25 13.7427 1.25736 14.7501 2.5 14.7501H11.5C12.7426 14.7501 13.75 13.7427 13.75 12.5001V7.00006H12.25V12.5001C12.25 12.9143 11.9142 13.2501 11.5 13.2501H2.5C2.08579 13.2501 1.75 12.9143 1.75 12.5001V3.50006C1.75 3.08585 2.08579 2.75006 2.5 2.75006H8V1.25006H2.5Z" />
                    </svg>
                    <div v-if="detail" class="mr-auto">手动刮削</div>
                </span>
            </label>
        </div>
        <!--自动刮削-->
        <div class="mt-2">
            <label for="auto-edit"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content drawer-button', !detail ? 'tooltip tooltip-top' : '']"
                data-tip="自动刮削">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else :class="['flex mt-1', 'items-center', detail ? 'w-40' : '']">
                    <svg t="1733029861980" class="icon fill-current w-16 h-5" viewBox="0 0 1036 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="9646" width="200" height="200">
                        <path
                            d="M938.74776 69.162438L893.455144 52.837457a67.26383 67.26383 0 1 0-20.007307 64.317969l42.469499 15.465771c28.722146 10.433258 53.516478 49.097686 53.516478 83.466066v598.869028c0 34.000148-24.548843 72.664576-53.639223 82.729601l-38.296195 13.501863a67.26383 67.26383 0 1 0 14.115585 66.650109l46.397313-16.447724c55.60313-19.51633 98.195372-83.711555 98.195373-146.311105V216.210008c0-62.354061-42.960475-126.917519-98.195373-147.293059zM222.16703 888.971053a66.895597 66.895597 0 0 0-52.166292 24.548843L121.516773 897.440403A89.1123 89.1123 0 0 1 67.26383 822.443688V208.722611a89.97151 89.97151 0 0 1 54.252943-76.101414l51.920803-18.657121a67.632063 67.632063 0 1 0-15.465771-65.913643L98.195372 69.285182A157.358084 157.358084 0 0 0 0 208.722611v613.721077a156.253386 156.253386 0 0 0 99.30007 138.332731L159.56748 982.011168a67.509318 67.509318 0 1 0 62.59955-93.040115z">
                        </path>
                        <path
                            d="M426.29066 572.413721l86.780161-205.105584 91.935417 205.105584z m282.311696 230.759125h119.798354l-267.58239-592.854561-98.195372 1.104698-251.625642 592.118096 118.079936-1.350187L380.507068 680.183142h272.492158l55.112153 122.744215z">
                        </path>
                    </svg>
                    <div v-if="detail" class="mr-auto">自动刮削</div>
                </span>
            </label>
        </div>
        <!--整理文件-->
        <div class="mt-2">
            <label for="tidy-folder"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content drawer-button', !detail ? 'tooltip tooltip-top' : '']"
                data-tip="整理文件">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else :class="['flex mt-1', 'items-center', detail ? 'w-40' : '']">
                    <svg t="1733030023556" class="icon fill-current w-16 h-6" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="10797" width="200" height="200">
                        <path
                            d="M512 133.034667L180.736 298.666667 512 464.298667 843.264 298.666667 512 133.034667z m19.072-85.845334l426.666667 213.333334a42.666667 42.666667 0 0 1 0 76.330666l-426.666667 213.333334a42.581333 42.581333 0 0 1-38.144 0l-426.666667-213.333334a42.666667 42.666667 0 0 1 0-76.330666l426.666667-213.333334a42.581333 42.581333 0 0 1 38.144 0z m388.522667 426.666667a42.666667 42.666667 0 0 1 38.186666 76.330667l-426.666666 213.333333a42.581333 42.581333 0 0 1-38.144 0l-426.666667-213.333333a42.666667 42.666667 0 0 1 38.186667-76.330667L512 677.632l407.594667-203.776z m0 213.333333a42.666667 42.666667 0 0 1 38.186666 76.330667l-426.666666 213.333333a42.581333 42.581333 0 0 1-38.144 0l-426.666667-213.333333a42.666667 42.666667 0 0 1 38.186667-76.330667L512 890.965333l407.594667-203.776z">
                        </path>
                    </svg>
                    <div v-if="detail" class="mr-auto">整理文件</div>
                </span>
            </label>
        </div>
        <!--简体转繁体-->
        <div class="mt-2">
            <button :theme="'success'" @click="handleChangeLanguage('sim2trad')"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content', !detail ? 'tooltip tooltip-top' : '']"
                data-tip="简体转繁体" :disabled="isLoading">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                    <svg t="1704703866798" class="icon w-16 h-6 fill-current" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="12326" width="200" height="200">
                        <path
                            d="M716.8 76.8a230.4 230.4 0 0 1 230.4 230.4v409.6a230.4 230.4 0 0 1-230.4 230.4H307.2a230.4 230.4 0 0 1-230.4-230.4V307.2a230.4 230.4 0 0 1 230.4-230.4h409.6m0-76.8H307.2A307.2 307.2 0 0 0 0 307.2v409.6a307.2 307.2 0 0 0 307.2 307.2h409.6a307.2 307.2 0 0 0 307.2-307.2V307.2A307.2 307.2 0 0 0 716.8 0z"
                            p-id="12327"></path>
                        <path
                            d="M319.744 309.76l-19.2 22.272h202.752c0 23.808 0 45.824-1.792 66.304h34.56v39.936h-37.632c0 9.472-2.304 21.248-4.864 35.584h23.296v32.512H486.4l-3.072 10.496 17.152 13.056a763.136 763.136 0 0 1-96 39.936l118.784-4.352c20.736-10.752 46.592-25.6 76.8-41.728l44.8 29.44a984.32 984.32 0 0 1-222.464 92.16q102.4-4.096 220.672-12.288c-17.152-13.056-30.208-22.528-39.424-28.416l44.288-28.16a1037.056 1037.056 0 0 1 136.448 97.792l-51.2 34.304c-11.52-11.008-25.6-24.064-44.288-39.424l-146.688 8.704v68.096c0 34.56-20.224 51.2-60.928 51.2h-54.016l-11.008-51.2a478.976 478.976 0 0 0 49.664 3.072 15.616 15.616 0 0 0 17.92-17.152v-51.2c-62.464 3.328-128 5.888-200.96 7.936l-13.568-51.2c17.152 1.28 34.304 1.792 51.2 1.792a784.64 784.64 0 0 0 128-39.936l-131.584 5.12-9.728-45.824a146.176 146.176 0 0 0 47.872-5.376 798.464 798.464 0 0 0 75.52-33.792l3.84-13.056h-174.848c4.864-30.208 8.192-52.992 10.24-68.096H232.448v-39.936h42.496c2.304-20.48 4.096-35.84 4.864-46.08l-19.712 17.152-33.28-39.168a329.984 329.984 0 0 0 86.784-102.4l52.736 11.776-15.36 27.136h177.664v43.008z m108.032 419.84a727.808 727.808 0 0 1-167.68 64l-23.296-49.152A623.104 623.104 0 0 0 394.752 691.2z m-106.24-296.96l-6.656 41.216h87.04a390.912 390.912 0 0 0-61.952-21.504l12.8-19.712z m41.728-68.608H330.24l-4.352 40.96h76.8a337.92 337.92 0 0 0-53.504-20.992z m44.288 109.824h35.584l6.912-41.216h-86.784a512 512 0 0 1 57.856 20.48z m44.8-68.864l1.792-40.96h-83.456a358.4 358.4 0 0 1 55.808 22.016l-12.288 18.944z m119.296-33.024q-9.216 11.264-27.648 30.72l-33.792-40.704a412.16 412.16 0 0 0 82.176-135.68l54.272 12.288-19.2 43.008h157.952v51.2h-34.304a284.928 284.928 0 0 1-51.2 107.52 469.248 469.248 0 0 0 98.304 43.776l-28.928 51.2a460.8 460.8 0 0 1-108.288-55.808 294.656 294.656 0 0 1-111.104 52.736l-28.928-45.568a270.336 270.336 0 0 0 99.072-43.008 237.568 237.568 0 0 1-48.384-71.68zM614.4 688.896A1068.032 1068.032 0 0 1 781.824 742.4l-32 51.2a926.464 926.464 0 0 0-168.448-57.088z m-9.216-358.4a180.736 180.736 0 0 0 51.2 76.8 244.736 244.736 0 0 0 41.728-76.8z"
                            p-id="12328"></path>
                    </svg>
                    <div v-if="detail" class="mr-auto">简体转繁体</div>
                </span>
            </button>
        </div>
        <div class="mt-2">
            <button :theme="'success'" @click="handleChangeLanguage('trad2sim')"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content', !detail ? 'tooltip tooltip-top' : '']"
                data-tip="繁体转简体" :disabled="isLoading">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                    <svg t="1704703916417" class="icon fill-current w-16 h-6" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="1378" width="200" height="200">
                        <path
                            d="M716.8 76.8a230.4 230.4 0 0 1 230.4 230.4v409.6a230.4 230.4 0 0 1-230.4 230.4H307.2a230.4 230.4 0 0 1-230.4-230.4V307.2a230.4 230.4 0 0 1 230.4-230.4h409.6m0-76.8H307.2A307.2 307.2 0 0 0 0 307.2v409.6a307.2 307.2 0 0 0 307.2 307.2h409.6a307.2 307.2 0 0 0 307.2-307.2V307.2A307.2 307.2 0 0 0 716.8 0z"
                            p-id="1379"></path>
                        <path
                            d="M335.616 322.048a489.728 489.728 0 0 1-48.384 68.352L232.96 355.328a366.848 366.848 0 0 0 78.08-128l61.44 13.568-9.728 25.6H512v55.808h-76.8a300.288 300.288 0 0 1 29.44 48.64l-56.32 21.504a535.296 535.296 0 0 0-39.424-70.144z m-61.952 143.36h63.744v332.8h-63.744z m79.104-97.792a628.48 628.48 0 0 1 73.728 76.8l-47.104 32.512A768 768 0 0 0 307.2 396.544z m45.056 122.368h235.264v241.92h-235.264z m60.672 94.464h114.944v-43.008h-114.944z m114.944 94.72V634.88h-114.944v44.288zM636.672 793.6l-15.36-57.856 54.016 2.048c12.8 0 19.2-8.96 19.2-25.6v-261.12h-223.744v-58.368H757.76V729.6c0 43.264-23.296 65.024-70.144 65.024z m-39.168-471.552a491.008 491.008 0 0 1-37.632 59.648l-54.016-35.072a338.432 338.432 0 0 0 63.232-119.808l60.928 13.568c-4.096 11.52-6.912 20.224-8.704 25.6h169.728v55.808h-88.064a332.8 332.8 0 0 1 27.136 43.776l-56.576 21.504a533.504 533.504 0 0 0-37.376-65.28z"
                            p-id="1380"></path>
                    </svg>
                    <div v-if="detail" class="mr-auto">繁体转简体</div>
                </span>
            </button>
        </div>
        <!--删除文件夹-->
        <div class="mt-2">
            <button :theme="'success'" onclick="remove_folder.showModal()"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content', !detail ? 'tooltip tooltip-top' : '']"
                data-tip="删除文件夹" :disabled="isLoading">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                    <svg class="icon fill-current w-16 h-5" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M9 0H5V1.5L9 1.5V0ZM0 2.5H14V4H12.75V11.75C12.75 12.9927 11.7426 14 10.5 14L3.65821 14C2.41556 14 1.4082 12.9927 1.4082 11.75V4H0V2.5ZM2.9082 4H11.25V11.75C11.25 12.1642 10.9142 12.5 10.5 12.5L3.6582 12.5C3.24399 12.5 2.9082 12.1642 2.9082 11.75V4ZM6.25 5.75V10.75H4.75V5.75H6.25ZM9.25 10.75V5.75H7.75V10.75H9.25Z" />
                    </svg>
                    <div v-if="detail" class="mr-auto">删除文件夹</div>
                </span>
            </button>
        </div>
        <!--拆分元数据-->
        <div class="mt-2">
            <label for="split-filename"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content drawer-button', !detail ? 'tooltip tooltip-top' : '']"
                data-tip="拆分元数据" :disabled="isLoading">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else :class="['flex mt-1', 'items-center', detail ? 'w-40' : '']">
                    <svg viewBox="0 0 14 16" class="icon fill-current w-16 h-5" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M2.5 0.25C1.25736 0.25 0.25 1.25736 0.25 2.5V3H1.75V2.5C1.75 2.08579 2.08579 1.75 2.5 1.75H11.5C11.9142 1.75 12.25 2.08579 12.25 2.5V3H13.75V2.5C13.75 1.25736 12.7426 0.25 11.5 0.25H2.5Z" />
                        <path
                            d="M1.75 13.5V7.5H0.25V13.5C0.25 14.7426 1.25736 15.75 2.5 15.75H11.5C12.7426 15.75 13.75 14.7426 13.75 13.5V7.5H12.25V13.5C12.25 13.9142 11.9142 14.25 11.5 14.25H2.5C2.08579 14.25 1.75 13.9142 1.75 13.5Z" />
                        <path d="M2.5 4.5H0.25V6H2.5V4.5Z" />
                        <path d="M6.51786 4.5H3.46429V6H6.51786V4.5Z" />
                        <path d="M10.5357 4.5H7.48214V6H10.5357V4.5Z" />
                        <path d="M13.75 4.5H11.5V6H13.75V4.5Z" />
                    </svg>
                    <div v-if="detail" class="mr-auto">拆分元数据</div>
                </span>
            </label>
        </div>
        <!--替换文本-->
        <div class="mt-2">
            <label for="replace-text"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content drawer-button', !detail ? 'tooltip tooltip-top' : '']"
                data-tip="替换文本" :disabled="isLoading">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                    <svg class="icon fill-current w-16 h-6" viewBox="0 0 12 16" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M12.0001 4.25006V5.75006L0 5.75006V4.93951L3.96979 0.969727L5.03045 2.03039L2.81078 4.25006L12.0001 4.25006ZM0.000116289 11.7501L0.000116348 10.2501L12 10.2501V11.0608L8.03045 15.0304L6.96979 13.9697L9.18946 11.7501H0.000116289Z" />
                    </svg>
                    <div v-if="detail" class="mr-auto">替换文本</div>
                </span>
            </label>
        </div>
        <!--格式转换-->
        <div class="mt-2">
            <label for="change-format"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content drawer-button', !detail ? 'tooltip tooltip-top' : '']"
                data-tip="格式转换" :disabled="isLoading">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                    <svg t="1704704621435" class="icon fill-current w-16 h-6" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="3438" width="200" height="200">
                        <path
                            d="M136.192 986.112C66.56 986.112 10.24 927.744 10.24 856.576v-141.312c0-71.68 56.32-130.048 125.952-130.048h241.664c69.632 0 125.952 58.368 125.952 130.048v141.312c0 71.68-56.32 130.048-125.952 130.048H136.192z m0-325.12c-28.672 0-52.224 24.064-52.224 54.272v141.312c0 29.696 23.552 54.272 52.224 54.272h241.152c28.672 0 52.224-24.064 52.224-54.272v-141.312c0-29.696-23.552-54.272-52.224-54.272H136.192z m485.888 308.736c-19.968 0-31.232-15.872-31.744-31.232-0.512-14.848 8.192-32.768 35.84-35.328 26.112-4.608 46.08-8.704 70.144-16.896l1.024-0.512h1.024c9.216 0 40.448-22.528 66.56-53.76l0.512-1.024 1.536-1.024h0.512c14.336-7.168 38.912-48.64 51.712-96.256 0.512-3.072 1.024-5.632 1.536-8.192l0.512-2.56c3.072-16.896 6.144-31.744 6.144-49.152 0-2.048 0-5.12-0.512-10.24-0.512-3.072-0.512-5.632-0.512-8.704l-37.376 45.568c-9.728 10.752-18.944 12.8-25.088 12.8-4.096 0-8.704-1.024-12.8-3.072-9.728-5.12-15.36-11.776-17.408-20.48-2.56-11.264 3.584-21.504 6.144-25.088l0.512-0.512 84.992-105.472c3.072-3.072 20.48-19.456 38.912-19.456 26.112 0 40.448 23.04 44.032 29.184l76.288 110.08s12.288 17.408-9.216 39.936c-7.168 7.168-15.36 11.264-23.04 11.264-9.728 0-15.872-5.632-16.896-6.656l-42.496-56.832v16.896c0 60.928-20.48 119.808-60.928 175.104-40.448 50.688-86.528 83.456-140.8 101.376-2.048 1.024-5.12 2.048-13.312 4.096l-4.096 1.024c-12.288 3.072-23.552 5.12-33.28 6.656h-18.432z m-456.704-451.584c-28.672 0-43.008-26.624-44.544-30.208l-71.68-113.152s-12.288-17.408 9.216-39.424c7.68-7.168 15.36-11.264 23.04-11.264 9.728 0 15.872 5.632 16.896 6.656l42.496 56.32v-1.536-6.144c0.512-25.6 3.584-51.2 8.704-75.776 11.776-48.64 38.912-94.208 82.432-139.776 41.984-38.912 90.624-64 139.776-72.192 17.408-4.608 34.816-4.608 52.224-4.608 9.728 0 15.36 13.312 15.872 26.112 1.024 17.92-7.68 37.888-35.84 40.96l-2.048 0.512c-19.968 4.096-40.448 8.192-59.904 16.384-38.4 15.872-67.584 39.936-94.72 76.8l-4.608 6.656-2.048-1.536c-6.144 8.704-20.992 35.84-28.672 71.168l-0.512 3.072-0.512 1.536v0.512c-0.512 2.048-5.12 25.088-5.12 51.2v4.096c0 3.072 0.512 6.656 0.512 9.728 0 1.536 0 2.56 0.512 4.096l33.792-40.96c9.728-10.752 18.944-12.8 25.088-12.8 4.608 0 8.704 1.024 12.8 3.072 9.728 5.12 15.36 11.776 17.408 19.968 1.536 7.68-0.512 16.896-6.144 25.088v0.512L204.8 498.176c-3.584 3.584-20.992 19.968-39.424 19.968z m471.04-42.496c-69.632 0-125.952-58.368-125.952-130.048V204.8c0-71.68 56.32-130.048 125.952-130.048h241.152C947.2 74.752 1003.52 133.12 1003.52 204.8v141.312c0 71.68-56.32 130.048-125.952 130.048h-241.152z m0-325.12c-28.672 0-52.224 24.064-52.224 54.272v141.312c0 29.696 23.552 54.272 52.224 54.272h241.152c28.672 0 52.224-24.064 52.224-54.272V204.8c0-29.696-23.552-54.272-52.224-54.272h-241.152z">
                        </path>
                    </svg>
                    <div v-if="detail" class="mr-auto">格式转换</div>
                </span>
            </label>
        </div>
        <!--分割音轨-->
        <div class="mt-2">
            <label for="split_cue"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content drawer-button', !detail ? 'tooltip tooltip-top' : '']"
                data-tip="分割音轨" :disabled="isLoading">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else :class="['flex mt-1', 'items-center', detail ? 'w-40' : '']">
                    <svg viewBox="0 0 16 14" class="icon fill-current w-16 h-5" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M6.00001 0.750244C6.00001 0.33603 5.66422 0.000244141 5.25001 0.000244141C4.83579 0.000244141 4.50001 0.336031 4.50001 0.750244L4.50001 1.10975C4.50001 1.72344 4.75068 2.31051 5.19395 2.73492L7.26701 4.71982L4.82988 7.09988C4.42039 7.49039 4.31633 8.10894 4.59285 8.61168L4.60292 8.63001L6.88601 12.2829C6.96051 12.4021 7.00001 12.5399 7.00001 12.6804V13.2502C7.00001 13.6645 7.33579 14.0002 7.75001 14.0002C8.16422 14.0002 8.50001 13.6645 8.50001 13.2502L8.50001 12.6804C8.50001 12.2587 8.3815 11.8455 8.158 11.4879L6.00724 8.04672L8.47876 5.63307C8.8733 5.28191 8.97223 4.73973 8.81074 4.29147C8.7162 4.02904 8.53253 3.85435 8.46556 3.79066L8.45717 3.78266L6.23132 1.65147C6.08357 1.51 6.00001 1.31431 6.00001 1.10975L6.00001 0.750244Z" />
                        <path
                            d="M2.5 1.75024C2.08421 1.75024 1.75 2.08446 1.75 2.50024V11.5002C1.75 11.916 2.08421 12.2502 2.5 12.2502H5.25C5.66421 12.2502 6 12.586 6 13.0002C6 13.4145 5.66421 13.7502 5.25 13.7502H2.5C1.25579 13.7502 0.25 12.7445 0.25 11.5002V2.50024C0.25 1.25603 1.25579 0.250244 2.5 0.250244H3.11C3.52421 0.250244 3.86 0.586031 3.86 1.00024C3.86 1.41446 3.52421 1.75024 3.11 1.75024H2.5Z" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M8.47296 2.23137C7.87783 1.41306 8.4474 0.250244 9.47952 0.250244H13.4995C14.7437 0.250244 15.7495 1.25603 15.7495 2.50024V11.5002C15.7495 12.7445 14.7437 13.7502 13.4995 13.7502H11.1795C10.7359 13.7502 10.302 13.5087 10.0856 13.0893L7.90236 9.06168L7.90098 9.05917C7.63468 8.57234 7.71835 7.95284 8.13705 7.5617L10.6534 4.96992L8.48264 2.24467L8.47296 2.23137ZM10.0065 1.75024L11.9884 4.23833L11.9998 4.25432C12.3627 4.7623 12.2997 5.45211 11.8588 5.88178L9.30861 8.50837L11.337 12.2502H13.4995C13.9153 12.2502 14.2495 11.916 14.2495 11.5002V2.50024C14.2495 2.08446 13.9153 1.75024 13.4995 1.75024H10.0065Z" />
                    </svg>
                    <div v-if="detail" class="mr-auto">分割音轨</div>
                </span>
            </label>
        </div>
        <!--导入收藏-->
        <div class="mt-2" v-if="getUserRole === 'V2'">
            <button :theme="'success'" onclick="import_music.showModal()"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content', !detail ? 'tooltip tooltip-top' : '']"
                data-tip="导入收藏" :disabled="isLoading">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                    <svg-icon name="import-music" class="w-16 h-6 fill-current" />
                    <div v-if="detail" class="mr-auto">导入收藏</div>
                </span>
            </button>
        </div>
        <!--乱码修复-->
        <div class="mt-2">
            <button :theme="'success'" onclick="fix_encoding.showModal()"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content', !detail ? 'tooltip tooltip-top' : '']"
                data-tip="乱码修复" :disabled="isLoading">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                    <svg-icon name="fix-encoding" class="w-16 h-7 fill-current" />
                    <div v-if="detail" class="mr-auto">乱码修复</div>
                </span>
            </button>
        </div>
        <!--重复文件检查-->
        <div class="mt-2" v-if="getUserRole === 'V2'">
            <button :theme="'success'" onclick="dup_check.showModal()"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content', !detail ? 'tooltip tooltip-top' : '']"
                data-tip="重复文件检查" :disabled="isLoading">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                    <svg-icon name="duplicate-file" class="w-16 h-6 fill-current" />
                    <div v-if="detail" class="mr-auto">重复文件检查</div>
                </span>
            </button>
        </div>
        <!-- 歌曲增益 -->
        <div class="mt-2">
            <button :theme="'success'" onclick="gain.showModal()"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content', !detail ? 'tooltip tooltip-top' : '']"
                data-tip="歌曲增益" :disabled="isLoading">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                    <svg-icon name="gain" class="w-16 h-6 fill-current" />
                    <div v-if="detail" class="mr-auto">歌曲增益</div>
                </span>
            </button>
        </div>
        <dialog id="gain" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box md:overflow-y-visible">
                <h3 class="text-lg font-bold">歌曲增益</h3>
                <div>
                    <div class="text-gray-400">通过扫描各个文件的音量大小，再将回放增益信息写入各个文件的属性标签中，播放的时候通过回放增益统一音量大小</div>
                    <div class="text-gray-400">需要下载<a href="https://johnvansickle.com/ffmpeg/" target="_blank"
                            style="color: blue;">ffmpeg</a>可执行文件
                    </div>
                    <div class="text-gray-400">放置在挂载的 /app/data/bin/ 目录下</div>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <!-- if there is a button in form, it will close the modal -->
                        <button class="btn btn-neutral btn-sm mr-2" @click="handleBatch(true)">确认</button>
                        <button class="btn btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>
        <dialog id="fix_encoding" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box md:overflow-y-visible">
                <h3 class="text-lg font-bold">乱码修复</h3>
                <div class="py-4 z-20">
                    <div>修复乱码的元数据</div>
                    <div>修改范围</div>
                    <multi-select :options="modifyListLanguage" v-model="modifyListL"></multi-select>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <!-- if there is a button in form, it will close the modal -->
                        <button class="btn btn-neutral btn-sm mr-2" @click="fixEncodingFunc">确认</button>
                        <button class="btn btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>
        <dialog id="dup_check" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box">
                <h3 class="text-lg font-bold">重复文件检查</h3>
                <div class="py-4">
                    <div>
                        <div class="text-gray-400">查找出重复的文件</div>
                        <div class="text-gray-400">不会自动删除您的文件，可以到操作记录中查看重复文件进一步删除操作。</div>
                        <div class="text-gray-400">支持根据hash校验重复和文件名称校验重复</div>
                    </div>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <!-- if there is a button in form, it will close the modal -->
                        <button class="btn btn-neutral btn-sm mr-2" @click="checkForDuplicates">确认</button>
                        <button class="btn btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>
        <dialog id="import_music" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box">
                <h3 class="text-lg font-bold">导入收藏</h3>
                <div class="py-4">
                    <div>将勾选的音乐导入音乐收藏库</div>
                    <div>
                        <div class="mt-2">跳过已入库的音乐文件:</div>
                        <div class="flex items-center">
                            <input type="checkbox" class="toggle toggle-primary mr-2" v-model="isSkipExist" />
                            <div v-if="isSkipExist">是</div>
                            <div v-else>否</div>
                        </div>
                    </div>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <!-- if there is a button in form, it will close the modal -->
                        <button class="btn btn-neutral btn-sm mr-2" @click="importMusic">确认</button>
                        <button class="btn btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>
        <dialog id="trans_font" ref="trans_font" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box md:overflow-y-visible">
                <h3 class="text-lg font-bold" v-if="exampleSetting4.primary.type === 'sim2trad'">简体转繁体</h3>
                <h3 class="text-lg font-bold" v-else>繁体转简体</h3>
                <div class="py-4 z-20">
                    <div>修改范围</div>
                    <multi-select :options="modifyListLanguage" v-model="modifyListL"></multi-select>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <!-- if there is a button in form, it will close the modal -->
                        <button class="btn btn-neutral btn-sm mr-2" @click="handleChangeLanguageFunc">确认</button>
                        <button class="btn btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>
        <dialog id="remove_folder" ref="remove_folder" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box md:overflow-y-visible">
                <h3 class="text-lg font-bold">删除文件夹</h3>
                <div class="py-4 z-20">
                    <div>删除文件夹或文件</div>
                    <div class="form-control w-72">
                        <label class="label cursor-pointer">
                            <input type="radio" name="radio-10" class="radio checked:bg-accent radio-accent"
                                value="null" v-model="deleteMode" />
                            <span class="label-text">删除空文件夹</span>
                        </label>
                    </div>
                    <div class="form-control w-72">
                        <label class="label cursor-pointer">
                            <input type="radio" name="radio-10" class="radio checked:bg-accent radio-accent"
                                value="null_music" v-model="deleteMode" />
                            <span class="label-text">删除无音乐文件夹</span>
                        </label>
                    </div>
                    <div class="form-control w-72">
                        <label class="label cursor-pointer">
                            <input type="radio" name="radio-10" class="radio checked:bg-red-500 radio-error" value="all"
                                v-model="deleteMode" />
                            <span class="label-text">删除勾选所有文件夹和文件（慎用）</span>
                        </label>
                    </div>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <!-- if there is a button in form, it will close the modal -->
                        <button class="btn btn-neutral btn-sm mr-2" @click="removeNullFolderFunc">确认</button>
                        <button class="btn btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>
        <div class="mt-2">
            <div class="drawer">
                <input id="auto-edit" type="checkbox" class="drawer-toggle" name='auto-edit'
                    v-model="autoModifyCheckBox" />
                <div class="drawer-content">
                </div>
                <div class="drawer-side">
                    <label for="auto-edit" aria-label="close sidebar" class="drawer-overlay"></label>
                    <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-96">
                        <div class="flex justify-between items-center mb-4">
                            <div class="text-xl font-medium">自动修改标签</div>
                            <button class="btn btn-sm btn-primary" @click="handleBatchAuto">保存</button>
                        </div>
                        <p class="text-gray-400">根据元数据中的标题、艺术家、专辑和文件名、文件完整路径进行匹配。</p>
                        <p class="text-gray-400 mb-2">标题、艺术家、专辑每一项匹配等级指标：完全一致，包含，不匹配</p>
                        <div class="form-control w-24">
                            <label class="label cursor-pointer">
                                <input type="radio" name="radio-auto-mode" class="radio checked:bg-red-500"
                                    value="simple" v-model="selectAutoMode" />
                                <span class="label-text tooltip tooltip-right"
                                    data-tip="至少存在一个完全一致和一个包含，但也优先选完全一致">宽松模式</span>
                            </label>
                        </div>
                        <div class="form-control w-24">
                            <label class="label cursor-pointer">
                                <input type="radio" name="radio-auto-mode" class="radio checked:bg-blue-500"
                                    value="normal" v-model="selectAutoMode" />
                                <span class="label-text tooltip tooltip-right"
                                    data-tip="三个指标必须为包含或完全一致，但也优先选完全一致">标准模式</span>
                            </label>
                        </div>
                        <div class="form-control w-24">
                            <label class="label cursor-pointer">
                                <input type="radio" name="radio-auto-mode" class="radio checked:bg-blue-500"
                                    value="hard" v-model="selectAutoMode" />
                                <span class="label-text tooltip tooltip-right" data-tip="三个指标必须都为完全一致">严格模式</span>
                            </label>
                        </div>
                        <div class="mt-2">音乐源顺序:</div>
                        <multi-select :options="resourceListBatch" v-model="sourceList"></multi-select>
                        <div class="mt-2">修改范围:</div>
                        <multi-select :options="modifyListBatch" v-model="modifyList"></multi-select>
                        <div class="mt-2">原有音乐标签将被保留，不会被修改或覆盖:</div>
                        <div class="flex items-center">
                            <input type="checkbox" class="toggle toggle-primary mr-2" v-model="isSkipTag" />
                            <div v-if="isSkipTag">是</div>
                            <div v-else>否</div>
                        </div>
                        <div class="text-gray-400">如修改范围中元数据都存在，则跳过匹配</div>
                        <div class="mt-2">同目录解释为同一个专辑:</div>
                        <div class="flex items-center">
                            <input type="checkbox" class="toggle toggle-primary mr-2" v-model="isFolderAlbum" />
                            <div v-if="isFolderAlbum">是</div>
                            <div v-else>否</div>
                        </div>
                        <div class="text-gray-400">当元数据中不存在专辑信息，用于补充专辑信息，提高匹配度</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="drawer">
            <input id="tidy-folder" type="checkbox" class="drawer-toggle" name='tidy-folder'
                v-model="tidyFolderCheckBox" />
            <div class="drawer-content">
                <!-- Page content here -->
            </div>
            <div class="drawer-side">
                <label for="tidy-folder" aria-label="close sidebar" class="drawer-overlay"></label>
                <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-96">
                    <div class="flex justify-between items-center mb-4">
                        <div class="text-xl font-medium">整理文件</div>
                        <button class="btn btn-sm btn-primary" @click="handleTidy">保存</button>
                    </div>
                    <p>整理文件夹，按一级目录，二级目录选定的信息分类</p>
                    <div>整理后的根目录</div>
                    <div class="input-demo">
                        <input type="text" placeholder="Type here" class="input input-sm input-bordered w-full max-w-xs"
                            v-model="tidyFormData.root_path" />
                    </div>
                    <div v-for="(input, index) in tidyFormData.dir_list" :key="index" style="margin-top: 10px;">
                        <div>第{{ index + 1 }}层目录</div>
                        <div class="flex">
                            <single-select v-model="input.value" :options="tidyList" :placeholder="'请选择'">
                            </single-select>
                            <button class="btn btn-sm ml-1" @click="removeInput(index)">x</button>

                        </div>
                        <div v-if="input.value === 'custom'">
                            <div>自定义变量：</div>
                            <single-input v-model="input.value2" placeholder="请输入自定义变量">
                            </single-input>
                        </div>
                    </div>
                    <button class="btn btn-sm mt-2" @click="addInput">添加目录</button>
                </div>
            </div>
        </div>
        <div class="drawer">
            <input id="hand-edit" type="checkbox" class="drawer-toggle" v-model="handModifyCheckBox" />
            <div class="drawer-content">
                <!-- Page content here -->
            </div>
            <div class="drawer-side">
                <label for="hand-edit" aria-label="close sidebar" class="drawer-overlay"></label>
                <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-96">
                    <div class="flex justify-between items-center mb-4">
                        <div class="text-xl font-medium">手动修改标签</div>
                        <button class="btn btn-sm btn-primary" @click="handleBatch(false)">保存</button>
                    </div>
                    <div style="display: flex;margin-bottom: 10px;align-items: center;margin-top: 10px;">
                        <div class="label1 can-copy" v-bk-tooltips="'变量名:${title}'" v-bk-copy="'${title}'">标题：</div>
                        <div style="width: 70%;">
                            <single-input v-model="musicInfoManual.title" placeholder="支持变量批量修改">
                            </single-input>
                        </div>
                    </div>
                    <div v-for="(item, index) in showFields" :key="'l2' + index">
                        <div class="edit-item" v-if="item === 'filename'">
                            <div class="label1 can-copy" v-bk-tooltips="'变量名:${filename}'" v-bk-copy="'${filename}'">
                                文件名：
                            </div>
                            <div style="width: 70%;">
                                <single-input v-model="musicInfoManual.filename" placeholder="例如：${title}-${album}">
                                </single-input>
                            </div>
                        </div>
                        <div class="edit-item" v-else-if="item === 'artist'">
                            <div class="label1 can-copy" v-bk-tooltips="'变量名:${artist}'" v-bk-copy="'${artist}'">
                                艺术家：
                            </div>
                            <div style="width: 70%;">
                                <single-input v-model="musicInfoManual.artist" placeholder="输入$查看可选择的变量">
                                </single-input>
                            </div>
                        </div>
                        <div class="edit-item" v-else-if="item === 'album'">
                            <div class="label1 can-copy" v-bk-tooltips="'变量名:${album}'" v-bk-copy="'${album}'">专辑：
                            </div>
                            <div style="width: 70%;">
                                <single-input v-model="musicInfoManual.album" placeholder="${null}为清空标签">
                                </single-input>
                            </div>
                        </div>
                        <div class="edit-item" v-else-if="item === 'albumartist'">
                            <div class="label1 can-copy" v-bk-tooltips="'变量名:${albumartist}'"
                                v-bk-copy="'${albumartist}'">专辑艺术家：
                            </div>
                            <div style="width: 70%;">
                                <div class="w-full max-w-xs">
                                    <single-select :options="albumArtistList" v-model="musicInfoManual.albumartist"
                                        is-var>
                                    </single-select>
                                </div>
                            </div>
                        </div>
                        <div class="edit-item" v-else-if="item === 'genre'">
                            <div class="label1">风格：</div>
                            <div style="width: 70%;">
                                <div class="w-full max-w-xs">
                                    <single-select :options="genreList" v-model="musicInfoManual.genre" is-var>
                                    </single-select>
                                </div>
                            </div>
                        </div>
                        <div class="edit-item" v-else-if="item === 'language'">
                            <div class="label1">语言：</div>
                            <div style="width: 70%;">
                                <div class="w-full max-w-xs">
                                    <single-select :options="languageList" v-model="musicInfoManual.language" is-var>
                                    </single-select>
                                </div>
                            </div>
                        </div>
                        <div class="edit-item" v-else-if="item === 'year'">
                            <div class="label1">年份：</div>
                            <div style="width: 70%;">
                                <single-input v-model="musicInfoManual.year" type="number">
                                </single-input>
                            </div>
                        </div>
                        <div style="display: flex;margin-bottom: 10px;flex-direction: column;"
                            v-else-if="item === 'lyrics'">
                            <div style="display: flex;">
                                <div class="label1">歌词：</div>
                                <div style="display: flex;flex-direction: column;width: 70%;">
                                    <div>
                                        <div class="form-control w-full max-w-xs">
                                            <textarea placeholder="请填入歌词" v-model="musicInfoManual.lyrics"
                                                class="textarea textarea-bordered textarea-xs w-full max-w-xs h-48">
                                                </textarea>
                                            <label class="label">
                                                <span class="label-text-alt">
                                                    <div style="display: flex;margin-top: 10px;margin-right: 20px;">
                                                        <div class="text-xs mr-2 tooltip"
                                                            data-tip="将元数据中的歌词导出为 ${filename}.lrc ">导出 lrc:</div>
                                                        <input type="checkbox" class="toggle toggle-xs toggle-primary"
                                                            v-model="isSaveLyricsFile" />
                                                    </div>
                                                </span>
                                                <span class="label-text-alt">
                                                    <div style="display: flex;margin-top: 10px;">
                                                        <div class="text-xs mr-2 tooltip"
                                                            data-tip="将${filename}.lrc文件导入元数据中的歌词处">导入 lrc:</div>
                                                        <input type="checkbox" class="toggle toggle-xs toggle-primary"
                                                            v-model="isImportLyricsFile" />
                                                    </div>
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="edit-item" v-else-if="item === 'comment'">
                            <div class="label1">简介：</div>
                            <div style="width: 70%;">
                                <textarea placeholder="请填入描述" v-model="musicInfoManual.comment"
                                    class="textarea textarea-bordered textarea-xs w-full max-w-xs">
                                    </textarea>
                            </div>
                        </div>
                        <div class="edit-item" v-else-if="item === 'description'">
                            <div class="label1">描述：</div>
                            <div style="width: 70%;">
                                <textarea placeholder="请填入描述" v-model="musicInfoManual.description"
                                    class="textarea textarea-bordered textarea-xs w-full max-w-xs">
                                    </textarea>
                            </div>
                        </div>
                        <div class="edit-item" v-else-if="item === 'album_img'">
                            <div class="label1">专辑封面：</div>
                            <div style="display: flex;flex-direction: column;">
                                <div style="width: 70%;display: flex;flex-direction: column;" v-if="reloadImg">
                                    <div>
                                        <bk-upload :files="files1" :theme="'picture'" :multiple="false"
                                            :with-credentials="true" :header="uploadHeader"
                                            :handle-res-code="handleResBatch" :size="{ maxFileSize: 5, maxImgSize: 20 }"
                                            :url="uploadUrl" @on-delete="handleHide" name="upload_file"></bk-upload>
                                    </div>
                                </div>
                                <div style="display: flex;margin-top: 10px;">
                                    <div class="text-xs mr-1">导出图片：</div>
                                    <input type="checkbox" class="toggle toggle-xs toggle-primary"
                                        v-model="isSaveAlbumCover" />
                                    <div class="text-xs mr-1 ml-8">导入图片：</div>
                                    <input type="checkbox" class="toggle toggle-xs toggle-primary"
                                        v-model="isImportAlbumCover" />
                                </div>
                            </div>
                        </div>
                        <div class="edit-item" v-else-if="item === 'discnumber'">
                            <div class="label1 can-copy" v-bk-tooltips="'变量名:${discnumber}'"
                                v-bk-copy="'${discnumber}'">光盘编号：
                            </div>
                            <div style="width: 70%;">
                                <single-input v-model="musicInfoManual.discnumber">
                                </single-input>
                            </div>
                        </div>
                        <div class="edit-item" v-else-if="item === 'tracknumber'">
                            <div class="label1 can-copy" v-bk-tooltips="'变量名:${tracknumber}'"
                                v-bk-copy="'${tracknumber}'">音轨号：
                            </div>
                            <div style="width: 70%;">
                                <single-input v-model="musicInfoManual.tracknumber">
                                </single-input>
                            </div>
                        </div>
                        <div class="edit-item" v-else-if="item === 'totaltracks'">
                            <div class="label1 can-copy">总音轨数：</div>
                            <div style="width: 70%;">
                                <single-input v-model="musicInfoManual.totaltracks">
                                </single-input>
                            </div>
                        </div>
                        <div class="edit-item" v-else-if="item === 'totaldiscs'">
                            <div class="label1">总光盘数：</div>
                            <div style="width: 70%;">
                                <single-input v-model="musicInfoManual.totaldiscs">
                                </single-input>
                            </div>
                        </div>
                        <div class="edit-item" v-else-if="item === 'album_type'">

                            <div class="label1">专辑类型：</div>
                            <div style="width: 70%;">
                                <single-select :options="albumTypeList" v-model="musicInfoManual.album_type">
                                </single-select>
                            </div>
                        </div>
                        <div class="edit-item" v-else-if="item === 'replaygain_album_gain'">
                            <div class="label1">专辑增益：</div>
                            <div style="width: 70%;">
                                <single-input v-model="musicInfoManual.replaygain_album_gain">
                                </single-input>
                            </div>
                        </div>
                        <div class="edit-item" v-else-if="item === 'replaygain_album_peak'">
                            <div class="label1">专辑峰值：</div>
                            <div style="width: 70%;">
                                <single-input v-model="musicInfoManual.replaygain_album_peak">
                                </single-input>
                            </div>
                        </div>
                        <div class="edit-item" v-else-if="item === 'replaygain_track_gain'">
                            <div class="label1">曲目增益：</div>
                            <div style="width: 70%;">
                                <single-input v-model="musicInfoManual.replaygain_track_gain">
                                </single-input>
                            </div>
                        </div>
                        <div class="edit-item" v-else-if="item === 'replaygain_track_peak'">
                            <div class="label1">曲目峰值：</div>
                            <div style="width: 70%;">
                                <single-input v-model="musicInfoManual.replaygain_track_peak">
                                </single-input>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="drawer">
            <input id="split-filename" type="checkbox" class="drawer-toggle" name='split-filename'
                v-model="splitFilenameCheckBox" />
            <div class="drawer-content">
                <!-- Page content here -->
            </div>
            <div class="drawer-side">
                <label for="split-filename" aria-label="close sidebar" class="drawer-overlay"></label>
                <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-96">
                    <div class="flex justify-between items-center mb-4">
                        <div class="text-xl font-medium">拆分元数据</div>
                        <button class="btn btn-sm btn-primary" @click="splitFilenameFunc">保存</button>
                    </div>
                    <div>将文件名称按正则匹配规则提取出来并赋值给艺术家，专辑，标题</div>
                    <div class="mt-2">
                        <div>修改范围：</div>
                        <select class="select select-bordered select-sm w-full max-w-xs" @change="handleExtractChange"
                            v-model="extractField">
                            <option v-for="option in extractList" :key="option.id" :id="option.id" :value="option.id"
                                class="bg-base-100">
                                {{ option.name }}
                            </option>
                        </select>
                        <div>拆分规则：</div>
                        <div v-for="(item, index) in ruleList" :key="index" class="flex justify-center items-center">
                            <div class="mr-2">{{ index + 1 }}.</div>
                            <input type="text" placeholder="请输入"
                                class="input input-bordered w-full max-w-xs input-sm mt-1" v-model="ruleList[index]" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="drawer">
            <input id="replace-text" type="checkbox" class="drawer-toggle" />
            <div class="drawer-content">
                <!-- Page content here -->
            </div>
            <div class="drawer-side">
                <label for="replace-text" aria-label="close sidebar" class="drawer-overlay"></label>
                <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-96">
                    <div class="flex justify-between items-center mb-4">
                        <div class="text-xl font-medium">替换文本</div>
                        <button class="btn btn-sm btn-primary" @click="replaceTextFunc">保存</button>
                    </div>
                    <div>
                        <div>
                            <div class="text-gray-400">将一些藏在元数据的无关信息清除，</div>
                            <div class="text-gray-400">支持文本替换和正则表达式替换</div>
                        </div>
                        <div class="mt-2">替换模式</div>
                        <single-select v-model="replaceMode" :options="replaceOptions"
                            :placeholder="'请输入搜索关键词, 按Enter确认'">
                        </single-select>
                        <div>修改范围</div>
                        <multi-select :options="modifyListLanguage" v-model="modifyListL"></multi-select>
                        <div class="mt-2">
                            <div v-for="(item, index) in replaceTextList" :key="index"
                                class="flex justify-center items-center mb-1">
                                <div class="mr-2">{{ index + 1 }}.</div>
                                <input type="text" placeholder="替换前"
                                    class="input input-bordered w-full max-w-xs input-sm mt-1" v-model="item.before" />
                                <input type="text" placeholder="替换后"
                                    class="input input-bordered w-full max-w-xs input-sm mt-1" v-model="item.after" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="drawer">
            <input id="change-format" type="checkbox" class="drawer-toggle" />
            <div class="drawer-content">
                <!-- Page content here -->
            </div>
            <div class="drawer-side">
                <label for="change-format" aria-label="close sidebar" class="drawer-overlay"></label>
                <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-96">
                    <div class="flex justify-between items-center mb-4">
                        <div class="text-xl font-medium">格式转换</div>
                        <button class="btn btn-sm btn-primary" @click="formatMusicFunc">保存</button>
                    </div>
                    <div>
                        <div>
                            <div class="text-gray-400">将音频转换成其他格式，保存在同目录下。</div>
                            <div class="text-gray-400">不会删除源文件</div>
                            <div class="text-gray-400">需要下载<a href="https://johnvansickle.com/ffmpeg/" target="_blank"
                                    style="color: blue;">ffmpeg</a>可执行文件
                            </div>
                            <div class="text-gray-400">放置在挂载的 /app/data/bin/ 目录下</div>
                        </div>

                        <div style="margin-top: 10px;margin-bottom: 5px;">目标格式</div>
                        <select class="select select-bordered select-sm w-full max-w-xs" v-model="selectFormat">
                            <option v-for="option in formatList" :key="'format' + option.id" :id="option.id"
                                :name="option.name" :value="option.id">
                                {{ option.name }}
                            </option>
                        </select>
                        <div style="margin-top: 10px;margin-bottom: 5px;">比特率</div>
                        <select class="select select-bordered select-sm w-full max-w-xs" v-model="selectBitRate">
                            <option v-for="option in bitRateList" :key="'format' + option.id" :id="option.id"
                                :name="option.name" :value="option.id">
                                {{ option.name }}
                            </option>
                        </select>
                        <div v-if="selectBitRate === 'custom'">
                            <div style="margin-top: 10px;margin-bottom: 5px;">自定义</div>
                            <input type="text" placeholder="请输入自定义的比特率"
                                class="input input-bordered input-sm w-full max-w-xs" v-model="selectBitRateCustom" />
                        </div>

                        <div style="margin-top: 10px;margin-bottom: 5px;">采样率</div>
                        <select class="select select-bordered select-sm w-full max-w-xs" v-model="selectSampleRate">
                            <option v-for="option in sampleRateList" :key="'format' + option.id" :id="option.id"
                                :name="option.name" :value="option.id">
                                {{ option.name }}
                            </option>
                        </select>
                        <div v-if="selectSampleRate === 'custom'">
                            <div style="margin-top: 10px;margin-bottom: 5px;">自定义</div>
                            <input type="text" placeholder="请输入自定义的采样率"
                                class="input input-bordered input-sm w-full max-w-xs"
                                v-model="selectSampleRateCustom" />
                            <p class="text-gray-400 text-sm">必须是目标格式支持的有效采样率值，否则将转换失败。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="drawer">
            <input id="split_cue" type="checkbox" class="drawer-toggle" />
            <div class="drawer-content">
                <!-- Page content here -->
            </div>
            <div class="drawer-side">
                <label for="split_cue" aria-label="close sidebar" class="drawer-overlay"></label>
                <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-96">
                    <div class="flex justify-between items-center mb-4">
                        <div class="text-xl font-medium">切分音轨</div>
                        <button class="btn btn-sm btn-primary" @click="splitCueFunc">保存</button>
                    </div>
                    <div>
                        <div class="py-4 text-gray-400">
                            <div>使用CUE标记文件无损切割整轨CD音轨</div>
                            <div>不会删除源文件</div>
                            <div>需要下载<a href="https://johnvansickle.com/ffmpeg/" target="_blank"
                                    style="color: blue;">ffmpeg</a>可执行文件
                            </div>
                            <div>放置在挂载的 /app/data/bin/ 目录下</div>
                        </div>
                        <div>目标格式</div>
                        <select class="select select-bordered select-sm w-full max-w-xs" v-model="selectFormat">
                            <option v-for="option in formatList2" :key="'format' + option.id" :id="option.id"
                                :name="option.name" :value="option.id">
                                {{ option.name }}
                            </option>
                        </select>
                        <div class="mt-2">是否删除源文件</div>
                        <input type="checkbox" class="toggle toggle-md toggle-primary" v-model="isDeleteSource">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SingleSelect from "@/components/iview/SingleSelect";
import SingleInput from "@/components/iview/SingleInput";
import MultiSelect from "@/components/iview/MultiSelect";
import SvgIcon from '@/components/SvgIcon.vue'

export default {
    name: 'batch-action',
    components: { SingleInput, SingleSelect, MultiSelect, SvgIcon },
    data() {
        return {
            detail: (localStorage.getItem('detail') || 'false') !== 'false',
            settingCheckBox: false,
            handModifyCheckBox: false,
            autoModifyCheckBox: false,
            tidyFolderCheckBox: false,
            splitFilenameCheckBox: false,
            isLoading: false,
            isShowDupCheck: false,
            batchSettingFormData: {
                'isOpenDetail': localStorage.getItem('isOpenDetail') !== 'false',
                'isDepth': localStorage.getItem('isDepth') === 'true',
                'limit': localStorage.getItem('limit') ? localStorage.getItem('limit') : 30
            },
            showFields: localStorage.getItem('showFields') ? JSON.parse(localStorage.getItem('showFields')) : ['filename', 'artist', 'album', 'albumartist', 'genre', 'year', 'lyrics', 'lyrics_file', 'comment', 'album_img', 'size', 'album_type', 'description', 'discnumber', 'tracknumber', 'totaltracks', 'totaldiscs', 'bit_rate', 'sample_rate', 'channels', 'bit_depth', 'language', 'duration'],
            showFieldsID3: localStorage.getItem('showFieldsID3') ? JSON.parse(localStorage.getItem('showFieldsID3')) : ['album_img', 'filename', 'title', 'artist', 'album', 'albumartist', 'lyrics', 'lyrics_file', 'year', 'genre'],
            fieldListID3: [
                { id: 'title', name: '标题' },
                { id: 'filename', name: '文件名' },
                { id: 'artist', name: '艺术家' },
                { id: 'album', name: '专辑' },
                { id: 'album_type', name: '专辑类型' },
                { id: 'albumartist', name: '专辑艺术家' },
                { id: 'discnumber', name: '光盘编号' },
                { id: 'tracknumber', name: '音轨号' },
                { id: 'totaltracks', name: '总音轨数' },
                { id: 'totaldiscs', name: '总光盘数' },
                { id: 'genre', name: '风格' },
                { id: 'year', name: '年份' },
                { id: 'lyrics', name: '歌词' },
                { id: 'lyrics_file', name: '歌词(LRC文件)' },
                { id: 'comment', name: '简介' },
                { id: 'description', name: '描述' },
                { id: 'album_img', name: '专辑封面' },
                { id: 'duration', name: '时长' },
                { id: 'size', name: '文件大小' },
                { id: 'bit_rate', name: '比特率' },
                { id: 'sample_rate', name: '采样率' },
                { id: 'channels', name: '声道' },
                { id: 'bit_depth', name: '位深度' },
                { id: 'language', name: '语言' },
                { id: 'composer', name: '作曲家' },
                { id: 'lyricist', name: '作词家' },
                { id: 'replaygain_track_gain', name: '曲目增益' },
                { id: 'replaygain_track_peak', name: '曲目峰值' },
                { id: 'replaygain_album_gain', name: '专辑增益' },
                { id: 'replaygain_album_peak', name: '专辑峰值' }
            ],
            replaceOptions: [
                { id: 'text', name: '全文替换' },
                { id: 'regex', name: '正则替换' }
            ],
            // ruleList: ['${tracknumber}\\.${title}', '${tracknumber} ${title}', '${title}-${artist}-${album}'],
            ruleList: ['(?P<tracknumber>\\d+)\\.(?P<title>\\w+)', '(?P<tracknumber>\\w+) (?P<title>\\w+)', '(?P<title>\\w+)-(?P<artist>\\w+)-(?P<album>\\w+)'],
            ruleListTitle: ['(?P<tracknumber>\\d+)\\.(?P<title>\\w+)', '(?P<tracknumber>\\w+) (?P<title>\\w+)', '(?P<title>\\w+)-(?P<artist>\\w+)-(?P<album>\\w+)'],
            ruleListLyrics: ['作曲.*[:：]{1}(?P<composer>.*)\n', '作词.*[:：]{1}(?P<lyricist>.*)\n',
                '曲.*[:：]{1}(?P<composer>.*)\n', '词.*[:：]{1}(?P<lyricist>.*)\n',
                'Composed by.*[:：]{1}(?P<composer>.*)\n', 'Lyrics by.*[:：]{1}(?P<lyricist>.*)\n'
            ],
            extractField: 'filename',
            extractList: [
                { id: 'filename', name: '文件名' },
                { id: 'title', name: '标题' },
                { id: 'lyrics', name: '歌词' }
            ],
            modifyListL: ['title', 'artist', 'album'],
            exampleSetting2: {
                primary: {
                    visible: false,
                    headerPosition: 'left'
                }
            },
            exampleSetting3: {
                primary: {
                    visible: false,
                    headerPosition: 'left'
                }
            },
            exampleSetting4: {
                primary: {
                    visible: false,
                    headerPosition: 'left',
                    type: ''
                }
            },
            exampleSetting5: {
                primary: {
                    visible: false,
                    headerPosition: 'left'
                }
            },
            exampleSetting6: {
                primary: {
                    visible: false,
                    headerPosition: 'left'
                }
            },
            exampleSetting7: {
                primary: {
                    visible: false,
                    headerPosition: 'left'
                }
            },
            exampleSetting8: {
                primary: {
                    visible: false,
                    headerPosition: 'left'
                }
            },
            exampleSetting9: {
                primary: {
                    visible: false,
                    headerPosition: 'left'
                }
            },
            exampleSetting11: {
                primary: {
                    visible: false,
                    headerPosition: 'left'
                }
            },
            exampleSetting12: {
                primary: {
                    visible: false,
                    headerPosition: 'left'
                }
            },
            modifyListLanguage: [
                { id: 'title', name: '标题' },
                { id: 'artist', name: '艺术家' },
                { id: 'album', name: '专辑' },
                { id: 'albumartist', name: '专辑艺术家' },
                { id: 'lyrics', name: '歌词' },
                { id: 'comment', name: '描述' },
                { id: 'filename', name: '文件名称' },
                { id: 'genre', name: '风格' },
                { id: 'composer', name: '作曲家' },
                { id: 'lyricist', name: '作词家' },
            ],
            replaceMode: 'text',
            replaceTextList: [
                { 'before': '', 'after': '' },
                { 'before': '', 'after': '' },
                { 'before': '', 'after': '' }
            ],
            selectFormat: '',
            isDeleteSource: false,
            formatList: [
                { id: '', name: '维持原格式' },
                { id: 'mp3', name: 'MP3' },
                { id: 'wav', name: 'WAV' },
                { id: 'flac', name: 'FLAC' },
                { id: 'wma', name: 'WMA' },
                { id: 'ogg', name: 'OGG' }
            ],
            formatList2: [
                { id: '', name: '维持原格式' },
                { id: 'mp3', name: 'MP3' },
                { id: 'wav', name: 'WAV' },
                { id: 'flac', name: 'FLAC' },
                { id: 'wma', name: 'WMA' },
                { id: 'ogg', name: 'OGG' }
            ],
            selectBitRate: '-1',
            selectBitRateCustom: '',
            bitRateList: [
                { id: '-1', name: '保持原样' },
                { id: '32', name: '32k' },
                { id: '64', name: '64k' },
                { id: '96', name: '96k' },
                { id: '128', name: '128k' },
                { id: '160', name: '160k' },
                { id: '192', name: '192k' },
                { id: '224', name: '224k' },
                { id: '256', name: '256k' },
                { id: '320', name: '320k' },
                { id: 'custom', name: '自定义' }
            ],
            selectSampleRate: '-1',
            selectSampleRateCustom: '',
            sampleRateList: [
                { id: '-1', name: '保持原样' },
                { id: '11025', name: '11025' },
                { id: '22050', name: '22050' },
                { id: '44100', name: '44100' },
                { id: '48000', name: '48000' },
                { id: 'custom', name: '自定义' }
            ],
            isKeepSource: true,
            musicInfoManual: {},
            albumTypeList: [
                { id: 'album;album', name: '普通(album;album)' },
                { id: 'ep', name: 'EP(ep)' },
                { id: 'album;compilation', name: '合集(album;compilation)' },
                { id: 'album;live', name: '现场(album;live)' },
                { id: 'album;remix', name: '混音(album;remix)' },
                { id: 'album;soundtrack', name: '原声(album;soundtrack)' },
                { id: 'album;demo', name: '演示(album;demo)' },
                { id: 'single', name: '单曲(single)' }
            ],
            isSaveLyricsFile: false,
            isSaveAlbumCover: false,
            isImportAlbumCover: false,
            isImportLyricsFile: false,
            reloadImg: true,
            uploadUrl: '/apimt/upload_image/',
            uploadHeader: [
                { name: 'X-CSRFToken', value: this.getCookie('django_vue_cli_csrftoken') },
                { name: 'AUTHORIZATION', value: this.getCookie('AUTHORIZATION') }
            ],
            files1: [],
            genreInputList: [],
            albumArtistInputList: [],
            genreList: [
                { 'id': '流行', name: '流行' },
                { 'id': '摇滚', name: '摇滚' },
                { 'id': '说唱', name: '说唱' },
                { 'id': '民谣', name: '民谣' },
                { 'id': '电子', name: '电子' },
                { 'id': '爵士', name: '爵士' },
                { 'id': '纯音乐', name: '纯音乐' },
                { 'id': '金属', name: '金属' },
                { 'id': '世界音乐', name: '世界音乐' },
                { 'id': '新世纪', name: '新世纪' },
                { 'id': '古典', name: '古典' },
                { 'id': '独立', name: '独立' },
                { 'id': '氛围音乐', name: '氛围音乐' }
            ],
            languageList: [
                { 'id': '中文', name: '中文' },
                { 'id': '英文', name: '英文' },
                { 'id': '日文', name: '日文' },
                { 'id': '韩文', name: '韩文' },
                { 'id': '泰文', name: '泰文' },
                { 'id': '未知', name: '未知' },
                { 'id': '${guess_language}', name: '自动识别' }
            ],
            tidyList: [
                { id: 'title', name: '标题' },
                { id: 'artist', name: '艺术家' },
                { id: 'album', name: '专辑' },
                { id: 'album_artist', name: '专辑艺术家' },
                { id: 'album_type', name: '专辑类型' },
                { id: 'genre', name: '风格' },
                { id: 'language', name: '语言' },
                { id: 'track_number', name: '音轨号' },
                { id: 'disc_number', name: '光盘编号' },
                { id: 'comment', name: '描述' },
                { id: 'custom', name: '自定义' }
            ],
            albumArtistList: [],
            tidyFormData: {
                root_path: localStorage.getItem('tidy_root_path') || '/app/media/',
                dir_list: [{ 'value': 'artist' }, { 'value': 'album' }]
            },
            isSkipTag: true,
            isSkipExist: true,
            isFolderAlbum: false,
            modifyList: ['artist', 'album', 'album_img', 'year', 'lyrics'],
            resourceListBatch: [
                { id: 'netease', name: '网易云音乐' },
                { id: 'migu', name: '咪咕音乐' },
                { id: 'qmusic', name: 'QQ音乐' },
                { id: 'kugou', name: '酷狗音乐' },
                { id: 'kuwo', name: '酷我音乐' },
                { id: 'itunes', name: 'iTunes' },
                { id: 'spotify', name: 'Spotify' },
                { id: 'musicbrainz', name: 'MusicBrainz' },
            ],
            modifyListBatch: [
                { id: 'title', name: '标题' },
                { id: 'artist', name: '艺术家' },
                { id: 'album', name: '专辑' },
                { id: 'albumartist', name: '专辑艺术家' },
                { id: 'album_img', name: '专辑封面' },
                { id: 'year', name: '年份' },
                { id: 'lyrics', name: '歌词' },
                { id: 'is_save_lyrics_file', name: '歌词(LRC文件)' },
                { id: 'discnumber', name: '光盘编号' },
                { id: 'tracknumber', name: '音轨号' },
                { id: 'composer', name: '作曲家' },
                { id: 'lyricist', name: '作词家' },
                { id: 'language', name: '语言' }
            ],
            selectAutoMode: 'simple',
            sourceList: ['netease', 'qmusic'],
            forceDeleteWithoutMusic: false,
            forceDeleteAll: false,
            deleteMode: 'null'
        }
    },
    computed: {
        ...mapGetters(['geFullPath', 'getUserRole']),
        filePath: {
            get() {
                const fullPath = this.geFullPath
                return fullPath
            }
        },
        checkedIds: {
            get() {
                return this.$store.state.common.checkedIds
            },
            set(value) {
                this.$store.commit('setCheckedIds', value)
            }
        },
        checkedData: {
            get() {
                return this.$store.state.common.checkedData
            },
            set(value) {
                this.$store.commit('setCheckedData', value)
            }
        }
    },
    methods: {
        handleBatchSettings() {
            window.localStorage.setItem('isOpenDetail', this.batchSettingFormData.isOpenDetail)
            window.localStorage.setItem('isDepth', this.batchSettingFormData.isDepth)
            window.localStorage.setItem('limit', this.batchSettingFormData.limit)
            const obj = JSON.stringify(this.showFieldsID3)
            window.localStorage.setItem('showFieldsID3', obj)
            this.settingCheckBox = false
            this.$myMsg.notify({
                title: '保存成功！',
                content: "设置已保存，请刷新页面生效",
                type: 'success',
                time: 2000,
            });
        },
        handleChangeLanguage(type) {
            this.exampleSetting4.primary.type = type
            this.$refs.trans_font.showModal()
        },
        removeNullFolderFunc() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: '发生提示',
                    content: "请先勾选文件或文件夹！",
                    type: 'warning',
                    time: 5000,
                });
                return
            }
            try {
                this.isLoading = true
                this.$api.Task.removeNullFolder(
                    {
                        'file_full_path': this.filePath,
                        'select_data': this.checkedData,
                        'delete_mode': this.deleteMode
                    }).then((res) => {
                        this.isLoading = false
                        if (res.result) {
                            this.$myMsg.notify({
                                title: '创建成功！',
                                content: "任务在后台努力运行中",
                                type: 'success',
                                time: 2000,
                            })
                            this.$parent.handleSearchFile()
                        } else {
                            this.$myMsg.notify({
                                title: '创建失败！',
                                content: res.message.data.message ? res.message.data.message : '创建失败',
                                type: 'error',
                                time: 5000,
                            })
                        }
                    })
                return true
            } catch (e) {
                console.warn(e)
                return false
            }
        },
        splitFilenameFunc() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: '发生提示',
                    content: "请先勾选文件或文件夹！",
                    type: 'warning',
                    time: 5000,
                });
                return
            }
            try {
                this.isLoading = true
                this.$api.Task.splitFilename(
                    {
                        'file_full_path': this.filePath,
                        'select_data': this.checkedData,
                        'rule_list': this.ruleList,
                        'extract_field': this.extractField
                    }).then((res) => {
                        this.isLoading = false
                        if (res.result) {
                            this.$myMsg.notify({
                                title: '创建成功！',
                                content: "任务在后台努力运行中",
                                type: 'success',
                                time: 2000,
                            })
                            this.$parent.handleSearchFile()
                        } else {
                            this.$myMsg.notify({
                                title: '创建失败！',
                                content: res.message.data.message ? res.message.data.message : '创建失败',
                                type: 'error',
                                time: 5000,
                            })
                        }
                    })
                return true
            } catch (e) {
                console.warn(e)
                return false
            }
        },
        replaceTextFunc() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: '发生提示',
                    content: "请先勾选文件或文件夹！",
                    type: 'warning',
                    time: 5000,
                });
                return
            }
            try {
                this.isLoading = true
                this.$api.Task.replaceText(
                    {
                        'file_full_path': this.filePath,
                        'select_data': this.checkedData,
                        'replace_text_list': this.replaceTextList,
                        'modify_list': this.modifyListL,
                        'replace_mode': this.replaceMode
                    }).then((res) => {
                        this.isLoading = false
                        if (res.result) {
                            this.$myMsg.notify({
                                title: '创建成功！',
                                content: "任务在后台努力运行中",
                                type: 'success',
                                time: 2000,
                            })
                            this.$parent.handleSearchFile()
                        } else {
                            this.$myMsg.notify({
                                title: '创建失败！',
                                content: res.message.data.message ? res.message.data.message : '创建失败',
                                type: 'error',
                                time: 5000,
                            })
                        }
                    })
                return true
            } catch (e) {
                console.warn(e)
                return false
            }
        },
        fixEncodingFunc() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: '发生提示',
                    content: "请先勾选文件或文件夹！",
                    type: 'warning',
                    time: 5000,
                });
                return
            }
            try {
                this.isLoading = true
                this.$api.Task.fixEncoding(
                    {
                        'file_full_path': this.filePath,
                        'select_data': this.checkedData,
                        'replace_text_list': this.replaceTextList,
                        'modify_list': this.modifyListL
                    }).then((res) => {
                        this.isLoading = false
                        if (res.result) {
                            this.$myMsg.notify({
                                title: '创建成功！',
                                content: "任务在后台努力运行中",
                                type: 'success',
                                time: 2000,
                            })
                            this.$parent.handleSearchFile()
                        } else {
                            this.$myMsg.notify({
                                title: '创建失败！',
                                content: res.message.data.message ? res.message.data.message : '创建失败',
                                type: 'error',
                                time: 5000,
                            })
                        }
                    })
                return true
            } catch (e) {
                console.warn(e)
                return false
            }
        },
        checkForDuplicates() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: '发生提示',
                    content: "请先勾选文件或文件夹！",
                    type: 'warning',
                    time: 5000,
                });
                return
            }
            try {
                this.isLoading = true
                this.$api.Task.checkDuplicate(
                    {
                        'file_full_path': this.filePath,
                        'select_data': this.checkedData,
                    }).then((res) => {
                        this.isLoading = false
                        if (res.result) {
                            this.$myMsg.notify({
                                title: '创建成功！',
                                content: "任务在后台努力运行中",
                                type: 'success',
                                time: 2000,
                            })
                            this.isShowDupCheck = false

                        } else {
                            this.$myMsg.notify({
                                title: '创建失败！',
                                content: res.message.data.message ? res.message.data.message : '创建失败',
                                type: 'error',
                                time: 5000,
                            })
                        }
                    })
                return true
            } catch (e) {
                console.warn(e)
                return false
            }
        },
        formatMusicFunc() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: '发生提示',
                    content: "请先勾选文件或文件夹！",
                    type: 'warning',
                    time: 5000,
                });
                return
            }
            try {
                this.isLoading = true
                this.$api.Task.formatMusic(
                    {
                        'file_full_path': this.filePath,
                        'select_data': this.checkedData,
                        'music_type': this.selectFormat,
                        'bit_rate': this.selectBitRate,
                        'bit_rate_custom': this.selectBitRateCustom,
                        'sample_rate': this.selectSampleRate,
                        'sample_rate_custom': this.selectSampleRateCustom,
                        'is_keep_source': this.isKeepSource
                    }).then((res) => {
                        this.isLoading = false
                        if (res.result) {
                            this.$myMsg.notify({
                                title: '创建成功！',
                                content: "任务在后台努力运行中",
                                type: 'success',
                                time: 2000,
                            })
                            this.$parent.handleSearchFile()
                        } else {
                            this.$myMsg.notify({
                                title: '创建失败！',
                                content: res.message.data.message ? res.message.data.message : '创建失败',
                                type: 'error',
                                time: 5000,
                            })
                        }
                    })
                return true
            } catch (e) {
                console.warn(e)
                return false
            }
        },
        splitCueFunc() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: '发生提示',
                    content: "请先勾选文件或文件夹！",
                    type: 'warning',
                    time: 5000,
                });
                return
            }
            try {
                this.isLoading = true
                this.$api.Task.splitCueMusic(
                    {
                        'file_full_path': this.filePath,
                        'select_data': this.checkedData,
                        'is_delete_source': this.isDeleteSource,
                        'target_format': this.selectFormat
                    }).then((res) => {
                        this.isLoading = false
                        if (res.result) {
                            this.$myMsg.notify({
                                title: '创建成功！',
                                content: "任务在后台努力运行中",
                                type: 'success',
                                time: 2000,
                            })
                            this.$parent.handleSearchFile()
                        } else {
                            this.$myMsg.notify({
                                title: '创建失败！',
                                content: res.message.data.message ? res.message.data.message : '创建失败',
                                type: 'error',
                                time: 5000,
                            })
                        }
                    })
                return true
            } catch (e) {
                console.warn(e)
                return false
            }
        },
        importMusic() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: '发生提示',
                    content: "请先勾选文件或文件夹！",
                    type: 'warning',
                    time: 5000,
                });
                return
            }
            this.isLoading = true

            this.$api.Task.importMusicIn({
                'file_full_path': this.filePath,
                'select_data': this.checkedData,
                'music_info': {},
                'is_skip_exist': this.isSkipExist
            }).then((res) => {
                this.isLoading = false
                if (res.result) {
                    this.$myMsg.notify({
                        title: '创建成功！',
                        content: "任务在后台努力运行中",
                        type: 'success',
                        time: 2000,
                    })
                } else {
                    this.$myMsg.notify({
                        title: '创建失败！',
                        content: res.message.data.message ? res.message.data.message : '创建失败',
                        type: 'error',
                        time: 5000,
                    })
                }
            })
        },
        handleBatch(isRegainer) {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: '发生提示',
                    content: "请先勾选文件或文件夹！",
                    type: 'warning',
                    time: 5000,
                });
                return
            }
            try {
                this.isLoading = true

                this.musicInfoManual.is_save_lyrics_file = this.isSaveLyricsFile
                this.musicInfoManual.is_import_lyrics_file = this.isImportLyricsFile
                this.musicInfoManual.is_save_album_cover = this.isSaveAlbumCover
                this.musicInfoManual.is_import_album_cover = this.isImportAlbumCover

                this.$api.Task.batchUpdateId3({
                    'file_full_path': this.filePath,
                    'select_data': this.checkedData,
                    'music_info': this.musicInfoManual,
                    'is_regainer': isRegainer
                }).then((res) => {
                    this.isLoading = false
                    if (res.result) {
                        this.handModifyCheckBox = false
                        this.$myMsg.notify({
                            title: '创建成功！',
                            content: "任务在后台努力运行中",
                            type: 'success',
                            time: 2000,
                            url: '/#/log'
                        });
                    }
                })
                return true
            } catch (e) {
                console.warn(e)
                return false
            }
        },
        handleResBatch(response) {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: '发生提示',
                    content: "请先勾选文件或文件夹！",
                    type: 'warning',
                    time: 5000,
                });
                return
            }
            if (response.result) {
                this.musicInfoManual.album_img = response.data
                return true
            } else {
                return false
            }
        },
        // 批量自动修改
        handleBatchAuto() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: '发生提示',
                    content: "请先勾选文件或文件夹！",
                    type: 'warning',
                    time: 5000,
                });
                return
            }
            try {
                this.isLoading = true
                this.musicInfoManual['select_mode'] = this.selectAutoMode
                this.musicInfoManual['source_list'] = this.sourceList
                this.musicInfoManual['is_skip_tag'] = this.isSkipTag
                this.musicInfoManual['is_folder_album'] = this.isFolderAlbum
                this.$api.Task.batchAutoUpdateId3({
                    'file_full_path': this.filePath,
                    'select_data': this.checkedData,
                    'music_info': this.musicInfoManual,
                    'modify_list': this.modifyList
                }).then((res) => {
                    this.isLoading = false
                    if (res.result) {
                        this.autoModifyCheckBox = false
                        this.$myMsg.notify({
                            title: '创建成功！',
                            content: "任务在后台努力运行中",
                            type: 'success',
                            time: 2000,
                            url: '/#/log'
                        });
                    }
                })
                return true
            } catch (e) {
                console.warn(e)
                return false
            }
        },
        // 整理文件夹
        handleTidy() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: '发生提示',
                    content: "请先勾选文件或文件夹！",
                    type: 'warning',
                    time: 5000,
                });
                return
            }
            try {
                this.isLoading = true
                this.tidyFormData['file_full_path'] = this.filePath
                this.tidyFormData['select_data'] = this.checkedData
                this.$api.Task.tidyFolder(this.tidyFormData).then((res) => {
                    this.isLoading = false
                    if (res.result) {
                        this.$myMsg.notify({
                            title: '创建成功！',
                            content: "任务在后台努力运行中",
                            type: 'success',
                            time: 2000,
                        })
                        window.localStorage.setItem('tidy_root_path', this.tidyFormData.root_path)
                        this.$parent.handleSearchFile()
                    } else {
                        this.$myMsg.notify({
                            title: '创建失败！',
                            content: res.message.data.message ? res.message.data.message : '创建失败',
                            type: 'error',
                            time: 5000,
                        })
                    }
                })
                return true
            } catch (e) {
                console.warn(e)
                return false
            }
        },
        handleChangeLanguageFunc() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: '发生提示',
                    content: "请先勾选文件或文件夹！",
                    type: 'warning',
                    time: 5000,
                });
                return
            }
            this.isLoading = true
            this.$api.Task.simplifiedFields({
                'mode': this.exampleSetting4.primary.type,
                'modify_list': this.modifyListL,
                'file_full_path': this.filePath,
                'select_data': this.checkedData
            }).then((res) => {
                this.isLoading = false
                if (res.result) {
                    this.$myMsg.notify({
                        title: '创建成功！',
                        content: "任务在后台努力运行中",
                        type: 'success',
                        time: 2000,
                    })
                } else {
                    this.$myMsg.notify({
                        title: '创建失败！',
                        content: res.message.data.message ? res.message.data.message : '创建失败',
                        type: 'error',
                        time: 5000,
                    })
                }
            })
        },
        addInput() {
            this.tidyFormData.dir_list.push({ value: '' }) // 添加新的输入框
        },
        removeInput(index) {
            this.tidyFormData.dir_list.splice(index, 1) // 删除指定索引的输入框
        },
        handleHide() {
            this.musicInfoManual.album_img = ''
        },
        handleExtractChange() {
            if (this.extractField === 'filename') {
                this.ruleList = this.ruleListTitle
            } else if (this.extractField === 'title') {
                this.ruleList = this.ruleListTitle
            } else if (this.extractField === 'lyrics') {
                this.ruleList = this.ruleListLyrics
            }
        },
        handleSetDetail() {
            this.detail = !this.detail
            window.localStorage.setItem('detail', this.detail ? 'true' : 'false')
        }
    }
}
</script>

<style scoped></style>
